import { styled } from '@mui/material/styles';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// styles
import { CommonFieldStyles } from '../styles';

export const DatePickerStyled = styled(DatePicker)(CommonFieldStyles);
